<!--影院详情-->
<template>
  <div v-if="list.length">
    <van-nav-bar
        title="影院-场次"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="header">
      <div class="cinema-name">{{form.cinemaName}}</div>
      <div class="cinema-address">{{form.address}}</div>
      <!--			<div class="cinema-remark">提示：{{serverListStr || '无'}}</div>-->
    </div>
    <div class="swiper-bg" :style="{backgroundImage:`url(${selectFilmInfo.pic})`}" v-if="selectFilmInfo.pic"></div>
    <div class="swiper" ref="swiper">
      <van-image
          v-for="item in imgList"
          :key="item.movieId"
          fit="aspectFill"
          :src="item.pic"
          class="swiper-img"
          :class="{active:item.movieId === selectFilmInfo.movieId}"
          @click="selectFilm(item)"
      >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>

    </div>
    <div class="movie-name">
      <div>{{list[imgIndex].name || '暂无影片'}}</div>
      <div>{{list[imgIndex].score || '暂无评'}}分</div>
    </div>
    <div class="movie-info">
      {{list[imgIndex].duration || 0}}分钟 | {{list[imgIndex].type || ''}} | {{list[imgIndex].leadingRole || ''}}
    </div>
    <div class="movie-dates">
      <div v-for="(item,index) in movieDates" :key="item.showid" :class="{'date-actived':index === dateCheckedIndex}" @click="chooseDate(index)">
        {{item.showDate}}
      </div>
    </div>
    <div class="movie-show-list">
      <div v-if="!movieList.length" style="text-align: center;">今日放映已结束</div>
      <div v-for="(item,index) in movieList" :key="item.show_time" v-else  @click="toBuy(item)">
        <div class="show-time">
          <div>{{item.showStartTime | show_time}}</div>
          <div class="end-time">{{item.showEndTime | show_time}}散场</div>
        </div>
        <div class="show-room">
          <div>{{item.showVersionType}}</div>
          <div>{{item.hallName}}</div>
        </div>
        <div class="price">
          <div>{{item.price | show_price}}元</div>
<!--          <div>市场价{{item.sellPrice | show_price}}元</div>-->
        </div>
        <div class="buy">
          <div>特惠购票</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCinemaInfo, getCinemaMoviesInfo} from '@/api/cinema'
import dayjs from 'dayjs'
import {getCookies} from "@/utils";
export default {
  name: "cinemaDetail",
  components: {},
  props: {},
  data() {
    return {
      showContent: false,
      cinemaid: '',
      movieId: '',
      form: {
        cinemaName: '',
        address: ''
      },
      selectFilmInfo:{}, // 已选择的电影信息
      list: [],
      imgList: [],
      serverList: [],
      serverListStr: '',
      imgIndex: 0, // 当前选中图片的序号
      movieDates: [], // 电影排期日期列表
      dateCheckedIndex:0 , // 当前选中的电影日期序号
      movieList: [], // 当日电影排期列表
    }
  },
  methods: {
    // 获取影院信息
    async getCinemaInfo() {
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      await getCinemaInfo({
        cinemaid: this.cinemaid
      }).then(res => {
        if (res?.data?.cinema_info) {
          this.form = res.data.cinema_info || {}
          if (this.form.cinema_service) {
            let obj = JSON.parse(this.form.cinema_service)
            this.serverList = Object.values(obj)
            this.serverListStr = this.serverList.join(' ')
          }
        }
        if (res?.data?.film_list) {
          this.list = res.data.film_list || []
          if (this.list.length) {
            this.imgList = []
            this.list.map(item => {
              this.imgList.push({
                pic:item.poster,
                type: 'image',
                name:item.name,
                grade:item.score, // 评分
                movieId:item.movieId
              })
            })
          }
        }
        if(this.imgList.length && this.movieId){
          this.imgIndex = this.imgList.findIndex(item=>item.movieId == this.movieId)
          this.selectFilmInfo = this.imgList.find(item=>item.movieId == this.movieId)
          if(this.imgIndex<0){
            this.imgIndex = 0
          }
          this.$nextTick(()=>{
            this.$refs.swiper.scrollLeft = (window.innerWidth / 750) * 230 * this.imgIndex
          })
        }
        this.getCinemaMoviesInfo()
      }).catch(e => {
        console.log(e)
      }).finally(()=>{
        this.$Toast.clear()
      })
    },
    // 获取某影片的排片数据
    getCinemaMoviesInfo(date){
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      getCinemaMoviesInfo({
        mobile: window.SITE_CONFIG['mobile'] || this.$store.state.cinema.mobile ,
        cinemaid:this.cinemaid,
        movieId:this.list[this.imgIndex].movieId,
        date:date
      }).then(res=>{
        // console.log(res)
        if(res?.data?.dates && !date){
          this.movieDates = res.data.dates.length ? res.data.dates : [{showDate:dayjs().format('YYYY-MM-DD')}]
          if(this.movieDates.length){
            this.getCinemaMoviesInfo(this.movieDates[0].showDate)
          }
        }
        if(res?.data?.show_list?.length && date){
          let arr = []
          res.data.show_list.map(item=>{
            if(dayjs().isBefore(dayjs(item.showStartTime))){
              arr.push(item)
            }
          })
          this.movieList = arr || []
        }else{
          this.movieList = []
        }
      }).catch(e=>{
        console.log(e)
        this.movieDates = []
        this.movieList = []
      }).finally(()=>{
        this.$Toast.clear()
      })
    },
    // 选择影片
    selectFilm(item){
      this.selectFilmInfo = item
      this.imgIndex = this.imgList.findIndex(ite=>ite.movieId == item.movieId)
      this.$refs.swiper.scrollLeft = (window.innerWidth / 750) * 230 * this.imgIndex
      this.getCinemaMoviesInfo()
    },
    // 选择日期
    chooseDate(index){
      this.dateCheckedIndex = index
      this.getCinemaMoviesInfo(this.movieDates[index].showDate)
    },
    // 购票
    toBuy(item){
      console.log(item)
      // 路由跳选座页
      // this.$router.push({
      //   path:'/seat',
      //   query:{
      //     showid: item.showId
      //   }
      // })

      // 跳转到选座h5
      window.location.href = `https://movie.fudd.com.cn?showid=${item.showId}&tel=${window.SITE_CONFIG['mobile'] || this.$store.state.cinema.mobile}&env=${window.SITE_CONFIG['theRequest'].env}&token=${getCookies('token')}&htmlType=h5`
    },
    onClickLeft(){
      this.$router.back()
    }
  },
  created() {
    this.cinemaid = this.$route.query.cinemaid
    this.movieId = this.$route.query.movieId
    this.getCinemaInfo()
  },
  mounted() {

  },
  filters:{
    show_time(val){
      if(val){
        let arr = val.split(' ')
        return arr[1]
      }
      return ''
    },
    show_price(val){
      if(val){
        return ((val-0)/100).toFixed(2)
      }
      return '-'
    }
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.main {
  font-size: 28px;
  color: #767877;
}

.header {
  padding: 16px;
  background-color: #ffffff;
}

.cinema-name {
  font-size: 36px;
  font-weight: bold;
  color: #090303;
}

.cinema-address {
  margin: 20px 0 0 0;
  font-size:24px;
}
.swiper-bg{
  height:360px;
  position: relative;
  z-index: 0;
  -webkit-filter: blur(.3rem) brightness(0.5);
  filter: blur(.3rem) brightness(0.5);
  background-size: cover;
  background-repeat: no-repeat;
  opacity: .85;
  background-position: 0 50% !important;
}
.swiper{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  padding:30px 45%;
  margin-top:-360px;
  overflow-x: auto;
  height:360px;
  .swiper-img{
    width: 200px;
    height: 280px;
    overflow: hidden;
    border-radius: 20px;
    margin-right:20px;
    flex: 1 0 auto;
    transform: scale(0.9);
    position: relative;
  }
  .active{
    transform: scale(1.1);
    border:6px solid #ffffff;
    &::after{
      content: "";
      position: absolute;
      bottom: -20px; /* 调整三角形与容器底部的距离 */
      left: 50%; /* 将三角形水平居中 */
      transform: translateX(-50%); /* 水平居中 */
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 20px solid white;
    }
  }
}
.movie-name{
  font-size:40px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color:#000000;
  padding:20px 0;
  &>div{
    margin:0 10px;
    &:last-child{
      color:#FFAA00;
      font-size:32px;
    }
  }
}
.movie-info{
  color:#A2A2A2;
  padding:0 40px 10px 40px;
  font-size:26px;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  background-color: #ffffff;
}
.movie-dates{
  padding:20px 30px 0 30px;
  overflow-x: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;
  color:#000000;
  background-color: #ffffff;
  font-size:34px;
  &>div{
    padding:20px;
    white-space: nowrap;
    flex: 0 1 auto;
    margin-right:20px;
  }
  .date-actived{
    //background-color: #e93323;
    //color:#ffffff;
    //border-radius:52px;
    color: #e93323;
    border-bottom: 6px solid #e93323;
    font-weight: bold;
  }
}
.movie-show-list{
  padding:20px;
  background-color: #F5F5F5;
  &>div{
    color:#000000;
    padding: 26px 30px 56px 30px;
    border-radius: 40px;
    background-color: #ffffff;
    margin:20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    position: relative;
    &>div{
      flex: 1 1 20%;
      text-align: left;
    }
    &:last-child{
      border:none;
    }
  }
  .show-time{
    font-size:40px;
    font-weight: bold;
    .end-time{
      color: #9a9a9a;
      font-size:26px;
      font-weight: normal;
      margin-top:10px;
    }
  }
  .price{

    &>div{
      //line-height: 28px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      &:first-child{
        color:#FF7744;
        margin-bottom:10px;
        font-size:40px;
        font-weight: bold;
      }
      //&:last-child{
      //  font-size:26px;
      //  color: #9a9a9a;
      //  text-decoration: line-through;
      //}
    }
    image{
      width:28px;
      height:28px;
      margin-right:6px;
    }
  }
  .show-room{
    width:40%;
    text-align: left;
    font-size:26px;
    &>div:last-child{
      color:#9a9a9a;
      margin-top:10px;
      position: relative;
      top: 10px;
    }
  }
  .buy{
    display: flex;
    justify-content: center;
    position: absolute;
    bottom:-42px;
    right:-42px;

    &>div{
      padding: 9px 74px 50px 34px;
      background-color: #C28650;
      color: #ffffff;
      border-radius: 60px;
      font-size: 26px;
    }
  }
}
</style>
